import type { ProductOut } from "@/lib/api";

type RigaClassificata = Pick<
  ProductOut,
  | "stato_offerta"
  | "attaccata_al_floor"
  | "sotto_margine"
  | "opportunita"
  | "senza_costo"
  | "senza_spedizione"
  | "prezzo_non_misurato"
  | "solo_listino"
>;

interface FiltroOfferta {
  label: string;
  test: (p: RigaClassificata) => boolean;
}

// Un filtro per ogni numero della Panoramica: il clic su un numero apre Prodotti
// con `?filtro=<chiave>` e la tabella mostra esattamente quelle offerte.
export const FILTRI_OFFERTA = {
  vinte: { label: "Vinte", test: (p) => p.stato_offerta === "vinta" },
  attaccate_al_floor: { label: "Attaccate al floor", test: (p) => p.attaccata_al_floor },
  recuperabili: { label: "Recuperabili", test: (p) => p.stato_offerta === "recuperabile" },
  al_limite: { label: "Al limite", test: (p) => p.stato_offerta === "al_limite" },
  perse_altro: { label: "Perse, altro", test: (p) => p.stato_offerta === "persa_altro" },
  sotto_margine: { label: "Sotto margine", test: (p) => p.sotto_margine },
  spente: { label: "Spente", test: (p) => p.stato_offerta === "spenta" },
  opportunita: { label: "Opportunità", test: (p) => p.opportunita },
  senza_costo: { label: "Senza costo", test: (p) => p.senza_costo },
  senza_spedizione: { label: "Senza spedizione", test: (p) => p.senza_spedizione },
  non_misurati: { label: "Non misurati", test: (p) => p.prezzo_non_misurato },
  solo_listino: { label: "Solo listino", test: (p) => p.solo_listino },
  a_margine: { label: "A margine", test: (p) => p.stato_offerta === "a_margine" },
  da_correggere: { label: "Da correggere", test: (p) => p.stato_offerta === "da_correggere" },
  senza_floor: { label: "Senza floor", test: (p) => p.stato_offerta === "senza_floor" },
  dati_mancanti: {
    label: "Dati mancanti",
    test: (p) => p.senza_costo || p.senza_spedizione || p.prezzo_non_misurato,
  },
} satisfies Record<string, FiltroOfferta>;

export type FiltroProdotti = keyof typeof FILTRI_OFFERTA;

export function filtroValido(valore: string | null): FiltroProdotti | null {
  return valore !== null && Object.hasOwn(FILTRI_OFFERTA, valore)
    ? (valore as FiltroProdotti)
    : null;
}

// Riga senza classificazione (nessuna offerta nostra, nessun segnale): base per
// le fixture e per i prodotti non ancora rilevati.
export const SENZA_CLASSIFICAZIONE: Pick<
  ProductOut,
  | "stato_offerta"
  | "attaccata_al_floor"
  | "riapre_sotto_margine"
  | "sotto_margine"
  | "scostamento_floor_pct"
  | "scostamento_floor_eur"
  | "scostamento_limite_pct"
  | "opportunita"
  | "senza_costo"
  | "senza_spedizione"
  | "prezzo_non_misurato"
  | "solo_listino"
> = {
  stato_offerta: null,
  attaccata_al_floor: false,
  riapre_sotto_margine: false,
  sotto_margine: false,
  scostamento_floor_pct: null,
  scostamento_floor_eur: null,
  scostamento_limite_pct: null,
  opportunita: false,
  senza_costo: false,
  senza_spedizione: false,
  prezzo_non_misurato: false,
  solo_listino: false,
};
